import Vue from 'vue'
// import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { store } from './store'
import VCalendar from 'v-calendar';


Vue.config.productionTip = false

Vue.use(VCalendar, {
    componentPrefix: 'vc'
  });
  

new Vue({
  router,
  vuetify,  
  store: store,
  render: h => h(App)
}).$mount('#app')
